$(document).ready(function () {
    setupInternationalPhoneNumberFields();

    document.addEventListener('myLLARegistrationStepSubmitted', function (e) {
        setupInternationalPhoneNumberFields();
    }, false);

    function setupInternationalPhoneNumberFields() {
        var errorMap = ["Invalid phonenumber", "Invalid country code", "Too short", "Too long", "Invalid phonenumber"];
        const internationalPhoneNumberFormGroups = document.querySelectorAll(".intTelInput");

        internationalPhoneNumberFormGroups.forEach(telephoneFormGroup => {
            var input = telephoneFormGroup.querySelector(".intTelInput-input");
            var hiddenInput = telephoneFormGroup.querySelector(".intTelInput-hidden input[type=hidden]");
            var errorMessage = telephoneFormGroup.querySelector(".intTelInput-error-msg");

            if (input && hiddenInput) {
                var iti = intlTelInput(input, {
                    utilsScript: "/intTelInputUtils.js",
                    initialCountry: "GB",
                    customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                        return "e.g. " + selectedCountryPlaceholder;
                    }
                });

                if (input.value != "") {
                    iti.setNumber(input.value);
                    validateNumber();
                }

                input.addEventListener("blur", function () {
                    validateNumber();
                });

                function validateNumber() {
                    if (input.value.trim()) {
                        hiddenInput.value = "";
                        errorMessage.innerHTML = "";
                        if (iti.isValidNumber()) {
                            hiddenInput.value = iti.getNumber(intlTelInputUtils.numberFormat.E164);
                            errorMessage.style.display = 'none';
                        } else {
                            var errorCode = iti.getValidationError();
                            errorMessage.innerHTML = errorMap[errorCode];
                            errorMessage.style.display = 'block';
                        }
                    } else {
                        hiddenInput.value = "";
                    }
                }
            }
        });
    }
});